import {auth, firebase, db} from '../firebase'
import axios from "axios";
// data inicial
const dataInicial = {
    loading: false,
    activo: false,
    permisos:"",

}

// types
const LOADING = 'LOADING'
const USUARIO_ERROR = 'USUARIO_ERROR'
const USUARIO_ERROR_LOGIN_EMAIL='USUARIO_ERROR_LOGIN_EMAIL'
const USUARIO_EXITO = 'USUARIO_EXITO'
const USUARIO_ROL = 'USUARIO_ROL'
const USUARIO_ERROR_ROL = 'USUARIO_ERROR_ROL'
const CERRAR_SESION = 'CERRAR_SESION'
const USUARIO_ADMINISTRADOR_EXITO = 'USUARIO_ADMINISTRADOR_EXITO'
const USUARIO_RESET_LOGIN_EMAIL = "USUARIO_RESET_LOGIN_EMAIL";

// reducer
export default function usuarioReducer (state = dataInicial, action) {
    switch(action.type){
        case LOADING:
            return {...state, loading: true}
        case USUARIO_ERROR:
            return {...dataInicial, error:action.error}
        case USUARIO_ERROR_LOGIN_EMAIL:
            return {...dataInicial, error:action.error}
        case USUARIO_EXITO:
            return {...state, loading: false, user: action.payload, activo: true}
        case USUARIO_ADMINISTRADOR_EXITO:
            return {...state, loading: false, user: action.payload, activo: true}
        case USUARIO_RESET_LOGIN_EMAIL:
            return {...dataInicial, error:action.error}
        case CERRAR_SESION:
            return {...dataInicial}
        default:
            return {...state}
    }
}
// action
export const ingresoUsuarioAccion = () => async(dispatch) => {
    dispatch({
        type: LOADING
    })
    try {
        const provider = new firebase.auth.GoogleAuthProvider();
        const res = await auth.signInWithPopup(provider)
        // console.log(res)

        try {
            const accountants = await db.collection(`${process.env.REACT_APP_COL_USERS}`)
            .doc(res.user.uid)
            .get();
            // console.log(accountants.data().roll)
        } catch (error) {
            await db.collection(`${process.env.REACT_APP_COL_USERS}`).doc(res.user.uid).set({
                email:res.user.email.toLowerCase(),
                uid:res.user.uid,
               // fechaIngreso: Date.now(),
                userPhone: res.user.providerData[0].phoneNumber,
                userName: res.user.displayName,
                userLastName:"",
                userCompany:"",
                acepTerminos:true,
                roll:'client',
                userActive:false,
                avatar:res.user.providerData[0].photoURL,
                //propietari:res.user.uid,
            })

        }


        const accountants = await db.collection(`${process.env.REACT_APP_COL_USERS}`)
        .doc(res.user.uid)
        .get();
        if(!accountants.data().roll){ console.log('crear usuario bicciexpress')
        console.log(accountants)
        try {
            await db.collection(`${process.env.REACT_APP_COL_USERS}`).doc(res.user.uid).set({
                email:res.user.email.toLowerCase(),
                uid:res.user.uid,
                createAdd: Date.now(),
                userPhone: res.user.providerData[0].phoneNumber,
                userName: res.user.displayName,
                userLastName:"",
                userCompany:"",
                acepTerminos:true,
                roll:'client',
                userActive:false,
                avatar:res.user.providerData[0].photoURL,
                propietari:"",
            }) 
        } catch (error) {
            console.log(error)
        }
        
        }
        // console.log(accountants.data().roll)
        rolldeUsuario(accountants.data().roll)
        dispatch({
            type: USUARIO_EXITO,
            payload: {
                uid: res.user.uid,
                email: res.user.email,
                roll:accountants.data().roll,

            }
        })
        localStorage.setItem('usuario', JSON.stringify({
            uid: res.user.uid,
            email: res.user.email,
            roll:accountants.data().roll,
        }))
        
    } catch (error) {
         console.log(error)
        dispatch({
            type: USUARIO_ERROR ,
            error:'Usuario no posee una cuenta, registre una nueva'
        })
    }
}
//FormLogig
export const ingresoUsuarioLogin = (email, pass) => async(dispatch) => {
    // console.log('ingresoUsuarioLogin')

    dispatch({
        type: LOADING
    })



    try { // Login con password
        const res = await auth.signInWithEmailAndPassword(email, pass)
         console.log(res.user.uid);  
            let userRoll = await db.collection(`${process.env.REACT_APP_COL_USERS}`)
            .doc(res.user.uid)
            .get();
             //console.log(userRoll.data())
             // Si el usuario no existe en bicci Express
            if(!userRoll.data()){ console.log('crear usuario bicciexpress')
            try {
                await db.collection(`${process.env.REACT_APP_COL_USERS}`).doc(res.user.uid).set({
                    email:email.toLowerCase(),
                    uid:res.user.uid,
                    createAdd: Date.now(),
                    userPhone: res.user.providerData[0].phoneNumber,
                    userName: res.user.displayName,
                    userLastName:"",
                    userCompany:"",
                    acepTerminos:true,
                    roll:'client',
                    userActive:false,
                    avatar:res.user.providerData[0].photoURL,
                    propietari:"",
                }) 
            } catch (error) {
                console.log(error)
            }

        
            }

            userRoll = await db.collection(`${process.env.REACT_APP_COL_USERS}`)
            .doc(res.user.uid)
            .get();

            rolldeUsuario(userRoll.data().roll)   
            // var response = await axios.get(
            //     `http://localhost:5001/bicci-dev-c842f/us-central1/bxEdihtUserRolBiccixpress`,
            //     { id: { id: res.user.uid } }
            //   );
            // console.log(response)
         dispatch({
             type: USUARIO_EXITO,
             payload: {
                 uid: res.user.uid,
                 email: res.user.email,
                 roll:userRoll.data().roll
             }
         })

         localStorage.setItem('usuario', JSON.stringify({
             uid: res.user.uid,
             email: res.user.email.at,
             roll:res.user.roll
         }
        
         )
         )
        
        } catch (error) {
             console.log(error)
            
            dispatch({
                type: USUARIO_ERROR_LOGIN_EMAIL,
                error:'Usuario o contraseña incorrectas'
            })
        }
}
//FormRegistro
export const crearUsuarioAccion = (data) => async(dispatch) => {
    dispatch({
        type: LOADING
    })
    try {
      //console.log('crearUsuarioAccion')
      //console.log(data)
        const res = await auth.createUserWithEmailAndPassword(data.email, data.pass)
        // console.log(res.user)
        function nombrePropio(name) {
            let nombre = name
            let cadena = nombre.toLowerCase().split(' ');
            for (var i = 0; i < cadena.length; i++) {
            cadena[i] = cadena[i].charAt(0).toUpperCase() + cadena[i].substring(1); }
            nombre = cadena.join(' ');
            return nombre
            }
        await db.collection(`${process.env.REACT_APP_COL_USERS}`).doc(res.user.uid).set({
            email:res.user.email.toLowerCase(),
            uid:res.user.uid,
           // fechaIngreso: Date.now(),
            userPhone: data.userPhone,
            userName: nombrePropio(data.username),
            userLastName:nombrePropio(data.userLastName),
            userCompany:data.companyName,
            acepTerminos:data.checked,
            roll:'client',
            userActive:false,
            //propietari:res.user.uid,
        })
        await db.collection(`${process.env.REACT_APP_COL_CONTACTS}`).doc(data.email.toLowerCase()).set({
            date: Date.now(),
            userName: nombrePropio(data.username) + nombrePropio(data.userLastName),
            userCompany:data.companyName,
            userType:"",
            email:data.email.toLowerCase(),
            userPhone: data.userPhone,
            lead:true,
            userPreferens:"",
            propietary:'bicci',
            acepTerminos:true,
            roll:'client',
            //     uid:data.uid,
            //     userLastName:data.userLastName,
         })
        dispatch({
            type: USUARIO_ADMINISTRADOR_EXITO,
            payload: {
                uid: res.user.uid,
                email: res.user.email,
                roll:res.user.roll,
            }
        })
  
        localStorage.setItem('usuario', JSON.stringify({
            uid: res.user.uid,
            email: res.user.email,
            roll:res.user.roll
        }))
        
    } catch (error) {
         console.log(error)
        dispatch({
            type: USUARIO_ERROR,
            error:'Usuario registrado en el entorno Bicci, puede ser como cliente o rider. Establezca su contraseña en el menú en el siguiente link', 
        })
    }
}
export const actualizarPassPorEnvioEmailUdk = (data) => async (dispatch) => {
    //// console.log(data.email)
    dispatch({
      type: LOADING,
    });
    try {
      // console.log(data.email);
  
      await auth.sendPasswordResetEmail(data.email);
      // console.log("Correo enviado...");
      dispatch({
        type: USUARIO_RESET_LOGIN_EMAIL,
        error:null,
    })
    } catch (error) {
       console.log(error);
      dispatch({
        type: USUARIO_ERROR,
        error:'Error 292: No existe usuario', 
      });
    }
  };
export const leerUsuarioActivoAccion = () => (dispatch) => {
    if(localStorage.getItem('usuario')){
     
        dispatch({
            type: USUARIO_EXITO,
            payload: JSON.parse(localStorage.getItem('usuario'))
        })
    }
}
// Expot Roll de usuario
//FormLogig
export const rolldeUsuario = (rollId) => async(dispatch) => {
    dispatch({
        type: LOADING
    })
    try {
        
        const userRoll = await db.collection(`${process.env.REACT_APP_COL_ROLES}`)
        .doc(rollId)
        .get();
        // console.log(userRoll.data())

        dispatch({
            type: USUARIO_ROL,
            permisos:userRoll.data(),
        })
        localStorage.setItem('ebiexservices', JSON.stringify({permisos:userRoll.data()}))
        
        
        } catch (error) {
            //// console.log(error.code)
            dispatch({
                type: USUARIO_ERROR_ROL,
                error:'Funciones de usuario No definidas 404',
            })
        }
}

export const cerrarSesionAccion = () => (dispatch) => {
    
    auth.signOut()    

    localStorage.removeItem('usuario')
 
    dispatch({
        type: CERRAR_SESION
     
    })
}


// Acesso rapido | Mi cuenta Perfil | BICCI XPRESS Admin - Operaciones - Ejecutivo | - Empresa - | conductor - Administrador de tienda | Empleado de tienda 
//Creacion de Usuario e-biex ||                    Acesso rapido  
//Roles: Admin - Operaciones - Ejecutivo = default Operador

//Crecion de Empresa
//Creacion de Usario Conductor
//Creacion de Usario Administrador de tienda
//Creacion de Usario Empleado de tienda
//Formulario de contacto


//Panel Administrativo | BICCI XPRESS Admin - Operaciones - Ejecutivo | - Empresa - | conductor - Administrador de tienda | Empleado de tienda 